
    import ConfBase from "./ConfBase.vue"

    export default {
        name: "ConfVm",
        extends: ConfBase,
    }
